"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _FeedbackSendStore = _interopRequireDefault(require("./FeedbackSendStore2"));

var FeedbackSendActions = /*#__PURE__*/function () {
  function FeedbackSendActions() {
    (0, _classCallCheck2["default"])(this, FeedbackSendActions);
  }

  (0, _createClass2["default"])(FeedbackSendActions, null, [{
    key: "feedbackMessageEnqueueAction",
    value: function feedbackMessageEnqueueAction(message) {
      _FeedbackSendStore["default"].feedbackMessageEnqueueAction(message);
    }
  }, {
    key: "feedbackMessageDequeueAction",
    value: function feedbackMessageDequeueAction() {
      _FeedbackSendStore["default"].feedbackMessageDequeueAction();
    }
  }]);
  return FeedbackSendActions;
}();

var _default = FeedbackSendActions;
exports["default"] = _default;